// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__e093m","modal__body":"modal_modal__body__tgWis","modal__close":"modal_modal__close__xAlo2","modal__content":"modal_modal__content__4xpWk"};